import React, { useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import styles from '../styles/Sidebar.module.css';
import { FaTachometerAlt, FaBoxOpen, FaClipboardList, FaUsers, FaThList, FaTags, FaHeadset, FaPalette, FaChevronDown, FaThLarge, FaEnvelope, FaQuestionCircle, FaLayerGroup } from 'react-icons/fa';
const navLinks = [
  { to: '/admin/dashboard', label: 'Dashboard', icon: <FaTachometerAlt className={styles.navIcon} /> },
  { to: '/admin/products', label: 'Products', icon: <FaBoxOpen className={styles.navIcon} /> },
  { to: '/admin/orders', label: 'Orders', icon: <FaClipboardList className={styles.navIcon} /> },
  { to: '/admin/users', label: 'Users', icon: <FaUsers className={styles.navIcon} /> },
  { to: '/admin/categories', label: 'Categories', icon: <FaThList className={styles.navIcon} /> },
  { to: '/admin/collections', label: 'Collections', icon: <FaLayerGroup className={styles.navIcon} /> },
  { to: '/admin/coupons', label: 'Coupons', icon: <FaTags className={styles.navIcon} /> },
];

const supportLinks = [
  { to: '/admin/support', label: 'Support Tickets', icon: <FaHeadset className={styles.navIcon} /> },
  { to: '/admin/support/contact', label: 'Inquiry', icon: <FaEnvelope className={styles.navIcon} /> },
  { to: '/admin/support/faq', label: 'FAQ', icon: <FaQuestionCircle className={styles.navIcon} /> },
];

const appSettingsLinks = [
  { to: '/admin/settings/landing', label: 'Landing Page', icon: <FaThLarge className={styles.navIcon} /> },
  { to: '/admin/settings/header', label: 'Header', icon: <FaThLarge className={styles.navIcon} /> },
  { to: '/admin/settings/footer', label: 'Footer', icon: <FaThLarge className={styles.navIcon} /> },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [supportOpen, setSupportOpen] = useState(false);

  // Open dropdown if on a sub-link
  React.useEffect(() => {
    if (location.pathname.startsWith('/admin/settings/')) {
      setSettingsOpen(true);
    }
    if (location.pathname.startsWith('/admin/support/')) {
      setSupportOpen(true);
    }
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    navigate('/');
  };

  return (
    <aside className={styles.sidebar}>
      {/* <div className={styles.logoSection}>
        <img src={process.env.PUBLIC_URL + '/logo192.png'} alt="KL Creation Logo" className={styles.logo} />
        <span className={styles.brand}>KL Creation</span>
      </div> */}
      <nav className={styles.navLinks}>
        {navLinks.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) => `${styles.link} ${isActive ? styles.active : ''}`}
          >
            {link.icon}
            {link.label}
          </NavLink>
        ))}
        
        {/* Support Dropdown */}
        <div className={styles.dropdown}>
          <button
            className={`${styles.dropdownToggle} ${location.pathname.startsWith('/admin/support/') ? styles.active : ''}`}
            onClick={() => setSupportOpen(o => !o)}
            aria-expanded={supportOpen}
          >
            <span className={styles.navIcon}><FaHeadset /></span>
            <span style={{ flex: 1, textAlign: 'left',marginRight: '1.4rem' }}>Supports</span>
            <span className={styles.dropdownIcon}><FaChevronDown className={supportOpen ? styles.open : ''} /></span>
          </button>
          {supportOpen && (
            <div className={styles.dropdownMenu}>
              {supportLinks.map(link => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) => `${styles.subLink} ${isActive ? styles.active : ''}`}
                  // onClick={() => setSupportOpen(false)}
                >
                  {link.icon}
                  {link.label}
                </NavLink>
              ))}
            </div>
          )}
        </div>

        {/* App Settings Dropdown */}
        <div className={styles.dropdown}>
          <button
            className={`${styles.dropdownToggle} ${location.pathname.startsWith('/admin/settings/') ? styles.active : ''}`}
            onClick={() => setSettingsOpen(o => !o)}
            aria-expanded={settingsOpen}
          >
            <span className={styles.navIcon}><FaPalette /></span>
            <span style={{ flex: 1, textAlign: 'left' }}>App Settings</span>
            <span className={styles.dropdownIcon}><FaChevronDown className={settingsOpen ? styles.open : ''} /></span>
          </button>
          {settingsOpen && (
            <div className={styles.dropdownMenu}>
              {appSettingsLinks.map(link => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) => `${styles.subLink} ${isActive ? styles.active : ''}`}
                  onClick={() => setSettingsOpen(false)}
                >
                  {link.icon}
                  {link.label}
                </NavLink>
              ))}
            </div>
          )}
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;